import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import './index.css';
import { UseLocalStorage } from "./functions";

function Logout() {
    console.log('Logout page load');
    const cookies = new Cookies();
    cookies.set('login', null);

    const [, setLocalStorageAttributes] = UseLocalStorage('attributes', []);
    const [, setLocalStorageTickets] = UseLocalStorage('tickets', []);
    const [, setLocalStorageCustomers] = UseLocalStorage('customers', []);

    const navigate = useNavigate();

    useEffect(() => {
        setLocalStorageAttributes(null);
        setLocalStorageTickets([]);
        setLocalStorageCustomers([]);
    }, []);

    setTimeout(() => {
        console.log('Navigating to Login page');
        navigate('/Login');
    }, 1500);

    return (
        <>
            <br />
            <div id="logoutResponse">Logout successful</div>
        </>
    );
};


export default Logout;
